<template>
  <section>
    <div class="container is-fluid">
      <div class="columns is-multiline">
        <div
          class="column is-one-third"
          v-for="note in $store.state.property.notes"
          :key="note.id"
        >
          <div class="card moveable-card">
            <div class="card-content">

              <div class="has-text-weight-semibold">{{ note.theNote }}</div>

              <div class="level">
                <div class="level-left">
                  <span>
                    <div class="is-size-7">{{ note.createdUtc | dateMedium }}</div>
                    <div class="is-size-7">{{ note.createdUtc | fromNow() }}</div>
                  </span>
                </div>
                <div class="level-right">
                  <b-icon
                    :pack="stageStyle(note.stage)"
                    v-bind:icon="stageStyle(note.stage)"
                    size="is-small"
                  ></b-icon>
                  <span class="is-size-7">{{ note.stage }}</span>
                </div>
              </div>

              <div class="level-left">
                <div class="level-item">
                  <span class="link">
                    <b-tooltip
                      label="Edit"
                      position="is-bottom"
                    >
                      <a
                        class="fas fa-edit"
                        @click="editNote(note)"
                      ></a>
                    </b-tooltip>
                  </span>
                </div>
                <div class="level-item">
                  <span class="icon">
                    <b-tooltip
                      label="Delete"
                      position="is-bottom"
                    >
                      <a
                        class="fas fa-trash"
                        @click="deleteNote(note)"
                      ></a>
                    </b-tooltip>
                  </span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :active.sync="isEditNoteActive"
      has-modal-card
      :canCancel="[]"
    >
      <EditNote
        v-bind:note="
      note"
        v-bind:propertyId="$store.state.property.id"
      >
      </EditNote>
    </b-modal>

  </section>

</template>

<script>
import store from "@/store";
import NewNote from "@/components/properties/notes/NewNote.vue";
import EditNote from "@/components/properties/notes/EditNote.vue";
import Helpers from "@/services/Helpers.js";

export default {
  components: {
    NewNote,
    EditNote
  },

  props: { propertyId: String },

  data() {
    return {
      note: "",
      isEditNoteActive: false
    };
  },

  methods: {
    stageStyle(stage) {
      return Helpers.getStageStyle(stage);
    },

    editNote(note) {
      this.note = note;
      this.isEditNoteActive = true;
    },

    deleteNote(note) {
      this.$buefy.dialog.confirm({
        title: "Deleting note",
        message: `<b>Delete this note?</b><br><br>${note.theNote}`,
        confirmText: "Delete Note",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          var propertyId = this.propertyId;
          var noteId = note.id;
          store.dispatch("deletePropertyNote", { propertyId, noteId });
          this.showSuccess(`Note deleted`);
        }
      });
    }
  }
};
</script>

<style>
</style>
